import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function WiderAudienceDialog({ privateNames, onConfirm, onCancel, confirmLabel = "Confirmar e publicar" }) {
  return (
    <AlertDialog open={!!privateNames} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent className="rounded-2xl max-w-sm w-[calc(100%-2rem)]" data-testid="wider-audience-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Visível fora da comunidade privada</AlertDialogTitle>
          <AlertDialogDescription>
            Esta publicação também ficará visível fora da comunidade privada nos destinos selecionados.
            {privateNames?.length ? <span className="block mt-2 text-xs">Comunidade(s) privada(s): <b>{privateNames.join(", ")}</b>. Os comentários e reações de cada destino continuam separados.</span> : null}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="wider-audience-cancel" className="rounded-xl">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); onConfirm(); }} data-testid="wider-audience-confirm" className="rounded-xl bg-[#c8102e] hover:bg-[#a50c24]">{confirmLabel}</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export function resultToast(toast, res, parts) {
  const failed = (res.community_results || []).filter((c) => c.status === "failed");
  const pending = (res.community_results || []).filter((c) => c.status === "pending_approval");
  if (failed.length) toast.error(`Não publicado em ${failed.map((c) => c.name).join(", ")}: ${failed[0].error || "sem permissão"}`);
  if (pending.length) toast.info(`${pending.map((c) => c.name).join(", ")}: a aguardar aprovação da moderação`);
  const ok = parts.filter((p) => !failed.some((f) => f.name === p));
  if (ok.length) toast.success(`Publicado em: ${ok.join(" · ")}`);
}
